import React, { useEffect, useState } from 'react'

import "common/css/master.css";
import "./panel.css";


function PanelTbl(props) {
  const { lstPanel, panelId, handleChangePanelObj,  editPanel, deletePanel, editPanelContent, playPanel } = props;

  const [selPanelId, setSelPanelId] = useState(0);
  const [lstPanelFiltered, setLstpanelFiltered] = useState([]);


  useEffect(() => {
    // console.log("PanelTbl called, panelId", panelId);
    setSelPanelId(panelId);
  }, [panelId]);

  useEffect(() => {
    // console.log("PanelTbl called, lstPanel", lstPanel);
    setLstpanelFiltered(lstPanel);
  }, [lstPanel]);

  const colgrp = <colgroup>
    <col width="60"></col>
    <col width="25"></col>
    <col width="35"></col>
    <col width="45"></col>
    <col width="45"></col>
    <col width="50"></col>
  </colgroup>
  return (
    <div >
      <div className="col-md-12 col-xs-12 col-centered padding-remove " >
        <table className="tableLayout1" >
          {colgrp}
          <thead>
            <tr>
              <th >
                Panel
              </th>
              <th >
                Layout
              </th>
              <th >
                Location
              </th>
              <th >
                Created On
              </th>
              <th >
                Content updated On
              </th>
              <th >
                Action
              </th>
            </tr>
          </thead>
        </table>
        <div className="tableDiv" style={{ height: "70vh" }}>
          <table className="tableLayout">
            {colgrp}
            <tbody id="panelPanelTbl" >
              {lstPanelFiltered &&
                lstPanelFiltered.map((panel, idx) => (
                  <tr key={panel.panelId}
                    onClick={() => handleChangePanelObj(panel)}
                    className={panel.panelId === selPanelId ? "selected" : ''}>
                    <td className="text-left">{panel.panel}</td>
                    <td className="text-center">
                      {panel.layoutTypeId === 10 ? (
                        <div className="card card-landscape"></div>
                      ) : panel.layoutTypeId === 20 ? (
                        <div className="card card-portrait"></div>
                      ) : panel.layoutTypeId === 30 ? (
                        <div className="card card-square"></div>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td className="text-center">{panel.location}</td>
                    <td className="text-center">{panel.createdDttm}</td>
                    <td className="text-center">{panel.contentDttm}</td>
                    <td className="text-center" >
                      <span
                        onClick={(e) => { e.stopPropagation(); editPanel(panel); }}
                        title="Edit "
                        style={{ textDecoration: "underline", cursor: "pointer", color: "blue", margin: "5px" }}
                      >
                        Edit
                      </span>
                      <span
                        onClick={(e) => { e.stopPropagation(); deletePanel(panel); }}
                        title="Delete "
                        style={{ textDecoration: "underline", cursor: "pointer", color: "blue", margin: "5px" }}
                      >
                        Delete
                      </span>
                      <span
                        onClick={(e) => { e.stopPropagation(); editPanelContent(panel); }}
                        title="Content "
                        style={{ textDecoration: "underline", cursor: "pointer", color: "blue", margin: "5px" }}
                      >
                        Content
                      </span>
                      <span
                        onClick={(e) => { e.stopPropagation(); playPanel(panel); }}
                        title="Play"
                        style={{ textDecoration: "underline", cursor: "pointer", color: "blue", margin: "5px" }}
                      >
                        Play
                      </span>
                    </td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default PanelTbl